// apps/web/src/lib/admin-cache.ts — Phase 5 plan 05-04 (ADM-01 follow-up).
//
// `useInvalidateAdminCaches()` is the SINGLE source of truth for
// TanStack-Query cache invalidation across the admin surface. Every
// admin mutation's `onSuccess` calls it.
//
// Per 05-04 key_links: the helper invalidates a fixed superset of 6
// key families (todaySummary, dateSummary, reservations, reservation,
// availability, slots). The cost of over-invalidating is low (the
// next refetch hits the DB); the cost of under-invalidating is stale
// UI after a mutation. The 05-04 admin-cache-invalidation test asserts
// every key is invalidated.

import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

const ADMIN_KEY_FAMILIES: ReadonlyArray<string> = [
  "todaySummary",
  "dateSummary",
  "reservations",
  "reservation",
  "availability",
  "slots",
];

export function useInvalidateAdminCaches(): () => void {
  const queryClient = useQueryClient();
  return useCallback(() => {
    for (const key of ADMIN_KEY_FAMILIES) {
      void queryClient.invalidateQueries({ queryKey: [key] });
    }
  }, [queryClient]);
}
